<div class="template-container">
  @if (this.currentItem.department && this.currentItem.professions) {
    <cam-department-professions class="ta-c" [professions]="this.currentItem.professions"></cam-department-professions>
  }

  <div class="text">
    {{ 'core.communicationhandler.template.mail.text' | translate }}
  </div>

  <div class="cta">
    <cam-loader [isLoading]="this.requestState.isLoading()">
      <div class="row">
        <div class="col-6">
          <cam-button (action)="this.cancel()" [style]="'danger'">
            {{ 'core.communicationhandler.template.cancel' | translate }}
          </cam-button>
        </div>
        <div class="col-6">
          <cam-button (action)="this.send()">
            {{ 'core.communicationhandler.template.send' | translate }}
          </cam-button>
        </div>
      </div>
    </cam-loader>
  </div>
</div>
